import React from 'react';
import { Row, Col, Button, Alert, ButtonToolbar } from 'react-bootstrap';

import FieldGroup from './common/FieldGroup.jsx';

export default class ItemsSerialNoComponent extends React.Component {

  componentDidMount() {
  }

  componentWillUnmount() {
    this.props.cleanAlert();
  }

  handleExport() {
    this.props.exportSerialNoList({ orderId: this.props.orderId });
  }

  render() {

    let roles = this.props.roles;
    let showFittingCrud = (roles.includes("ROLE_FIREFIGHTER_LABEL")) ? '' : 'none';

    let alertDiv = null;
    if (this.props.alertStyle || this.props.alertMessage) {
      alertDiv = (
        <Alert bsStyle={this.props.alertStyle} onDismiss={this.props.cleanAlert}>
          {this.props.alertMessage}
        </Alert>
      );
    }

    let downloadLinkStyle = {
      display: this.props.serialNoDownloadUrl === '' ? 'none' : 'block'
    };

    let openXls = () => {
      window.open(this.props.serialNoDownloadUrl);
    };

    return (
      <div>
        <div style={{ display: showFittingCrud }}>
          <Row style={{ marginTop: 10, marginBottom: 10 }}>
            <Col xs={12} sm={12} md={12}>
              {alertDiv}
              <ButtonToolbar>
                <Button onClick={this.props.generateCareLabels} bsStyle="info">
                  產生洗標/序號表
					      </Button>
                <Button onClick={this.props.deleteCareLabels} bsStyle="default">
                  <span className="glyphicon glyphicon-trash" style={{ marginRight: 10, color: '#a94442' }} />
                  <span style={{ color: '#a94442' }}>刪除洗標/序號表</span>
                </Button>
                <Button bsStyle="info" onClick={(event) => {
                      this.handleExport();
                    }}>匯出序號表xls檔</Button>
                <Button style={downloadLinkStyle} bsStyle="default" onClick={openXls}>開啟序號表xls檔</Button>
              </ButtonToolbar>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={12} md={12}>
              {this.props.noSerialNoCountMessage}
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={6} md={6}>
              <FieldGroup
                id="careLabel"
                type="text"
                label="洗標註解 (p.s 輸入#{姓名} 可自動捉取訂購者名稱)"
                value={this.props.careLabel.get('careLabel')}
                placeholder=""
                onChange={(id, value) => {
                  this.props.setValue(id, value);
                }}
                validation={this.props.careLabelValidation.get('careLabel')}
                componentClass="textarea"
                rows="3"
              />
            </Col>
            <Col xs={12} sm={6} md={6}>
              <FieldGroup
                id="manufactureDate"
                type="date"
                label="製造日期"
                value={this.props.careLabel.get('manufactureDate')}
                placeholder=""
                required="true"
                onChange={(id, value) => {
                  this.props.setValue(id, value);
                }}
                validation={this.props.careLabelValidation.get('manufactureDate')}
              />
            </Col>
          </Row>
        </div>
        <Row>
          <Col xs={12} sm={12} md={12}>
            {this.props.statSerialNoDataListDisplay}
          </Col>
        </Row>
      </div>
    )
  }
};


// WEBPACK FOOTER //
// ./src/components/ItemsSerialNoComponent.jsx